// extracted by mini-css-extract-plugin
export default {"list":"EssayListBlock_list__gCgC4"};